import createSelector from 'web-app/util/custom-create-selector';
import { isPinApp, isLoggedIn, isQrSignin } from 'signin-app/login/selectors';
import * as GoHomeWithSelectors from 'signin-app/go-home-with/selectors';
import { usesSelectChildrenScreen } from 'signin-app/select-children/uses-select-children-screen';
import { hasSignInRedesign } from 'signin-app/select-children/has-sign-in-redesign';
import RoutesMap from 'signin-app/routes/routes-map';
export const didInsertPin = (state) => state.pin.didInsertPin;
export const pinHolder = (state) => state.pin.pinHolder;
export const pinLoginId = (state) => { var _a; return (_a = state.pin.people) === null || _a === void 0 ? void 0 : _a.loginId; };
export const pinCanOpenDoor = (state) => { var _a; return (_a = state.pin.people) === null || _a === void 0 ? void 0 : _a.canOpenDoor; };
export const pinOpenDoorExpiration = (state) => { var _a; return (_a = state.pin.people) === null || _a === void 0 ? void 0 : _a.openDoorExpiration; };
export const pinOpenDoorHmac = (state) => { var _a; return (_a = state.pin.people) === null || _a === void 0 ? void 0 : _a.openDoorHmac; };
export const isLoggingIn = (state) => state.pin.isLoggingIn;
export const pinLoginResponse = (state) => state.pin.people;
const failedToLogIn = (state) => state.pin.failedToLogIn;
export const pinState = createSelector(isLoggingIn, failedToLogIn, (isLoggingIn, failedToLogIn) => {
    if (isLoggingIn) {
        return 'Loading';
    }
    else if (failedToLogIn) {
        return 'Error';
    }
    else {
        return 'Success';
    }
});
const pinChildById = createSelector(pinLoginResponse, (_, props) => props.childId, (people, childId) => {
    return people === null || people === void 0 ? void 0 : people.children.find(child => child.child.id === childId);
});
const goHomeWithChildId = createSelector(pinChildById, pinChild => {
    return pinChild === null || pinChild === void 0 ? void 0 : pinChild.child.goHomeWithChildId;
});
export const goHomeWithChild = createSelector(GoHomeWithSelectors.groups, goHomeWithChildId, (groups, goHomeWithChildId) => {
    let child;
    groups.some(group => {
        child = group.children.find(child => child.id === goHomeWithChildId);
        return Boolean(child);
    });
    return child;
});
export const isCompletelyLoggedIn = createSelector(isLoggedIn, didInsertPin, (hasToken, hasPin) => hasToken && hasPin);
export const isAuthorized = createSelector(isPinApp, didInsertPin, isLoggedIn, (pinApp, hasPin, hasToken) => {
    return pinApp ? hasPin && hasToken : hasToken;
});
export const redirectUrl = createSelector(isLoggedIn, isQrSignin, isPinApp, didInsertPin, pinLoginResponse, usesSelectChildrenScreen, hasSignInRedesign, 
// Read here rather than through the groups selectors, which load the entity modules and their import cycle
(state) => Boolean(state.institutionOverview.institution), (loggedIn, qrSignIn, pinApp, hasPin, pinPeople, selectsChildren, hasNewerScreens, overviewLoaded) => {
    if (loggedIn && qrSignIn && !pinApp) {
        return '/qr';
    }
    else if (loggedIn && pinApp) {
        // The site's features decide which screens open, and a PIN typed straight away can beat the overview
        if (hasPin && pinPeople && overviewLoaded) {
            const loggedInEmployee = pinPeople.employees.first();
            const loggedInChild = pinPeople.children.first();
            if (selectsChildren) {
                return RoutesMap.selectChildren;
            }
            if (loggedInChild) {
                if (loggedInChild.child.checkedIn) {
                    return `/child/${loggedInChild.child.id}/checkout`;
                }
                else {
                    return `/child/${loggedInChild.child.id}/checkin`;
                }
            }
            else if (loggedInEmployee) {
                if (hasNewerScreens) {
                    return `/select-staff/${loggedInEmployee.employee.employeeId}`;
                }
                if (loggedInEmployee.employeeCheckin) {
                    return `/employee/${loggedInEmployee.employee.employeeId}/checkout`;
                }
                else {
                    return `/employee/${loggedInEmployee.employee.employeeId}/checkin`;
                }
                // The entered PIN was correct but backend didn't send data either for a child or an employee
            }
            else {
                return '';
            }
        }
        else {
            return '';
        }
    }
    else {
        return '/';
    }
});
